/* eslint-disable @typescript-eslint/no-explicit-any */
import {postFormData} from '../technique/api';

export const retraiteBDL = () => ({
  souscrire: (data: any) => postFormData('retraite/contrat/retraite', data),
});
